import { auth } from "../../src/firebase";
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  signInWithEmailAndPassword,
  updatePassword,
} from "firebase/auth";
import { errorMessagesFirebaseAuth } from "../utils/errorMessagesFirebaseAuth";

export const signin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error) {
    throw new Error(errorMessagesFirebaseAuth[error.code] || error.message);
  }
};

/**
 * change user password
 * @param {string} currentPassword
 * @param {string} newPassword
 */
export const changePassword = async (currentPassword, newPassword) => {
  // console.table({ currentPassword, newPassword, confirmPassword });
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }
    const credential = EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    const result = await reauthenticateWithCredential(user, credential);
    await updatePassword(user, newPassword);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
